<template>
  <div class="row">
    <div class="col-12">
      <hours
        scope="hnp"
        :filters="filters"
      >
        <fa-icon
          :icon="['fab','creative-commons-nc-eu']"
          class="mr-2"
        /> Horas no productivas
      </hours>
    </div>
    <div class="col-12">
      <hours
        scope="hp"
        :filters="filters"
      >
        <fa-icon
          :icon="['fas','euro-sign']"
          class="mr-2"
        /> Horas productivas
      </hours>
    </div>
    <div class="col-md-6 col-12">
      <gauge :filters="filters">
        Media
      </gauge>
    </div>
  </div>
</template>

<script>
import hours from './widgets/hours';
import gauge from './widgets/gauge';

export default {
	name: 'Dashboard',
	components: {
		hours,
		gauge
	},
	computed: {
		filters: {
			get() {
				const data = this.$vault.get('stats_data');

				if (data) {
					return {
						turns: data.turns ? data.turns : [],
						groups: data.groups ? data.groups : [],
						articles: data.articles ? data.articles : [],
						operators: data.operators ? data.operators : []
					};
				}

				return {
					turns: [],
					groups: [],
					articles: [],
					operators: []
				};
			},
			set(val) {
				return this.$vault.set('stats_data', val);
			}
		}
	},
	async created() {
		this.$hub.$on('refrehFilters', () => {
			this.$vault.set('stats_data', null);
			this.listFilters();
		});

		this.listFilters();
	},
	beforeDestroy() {
		this.$hub.$off('refrehFilters');
	},
	methods: {

		async listFilters() {
			const data = this.$vault.get('stats_data');

			if (!data) {
				const result = await this.$lambda.get('stats/data');
				if (result.ok) this.filters = result.data.data;
			}
		}
	}
};
</script>

<style lang="scss" scoped>

</style>
